module.exports = __webpack_public_path__ + "78aabf83a8ba11834ff7629a953bf3f5.MP3";